import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Alert,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import instance from "../utils/axiosInstance";
import detectEthereumProvider from "@metamask/detect-provider";

const MetaRegister = () => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleMetaRegister = async () => {
    try {
      const provider = await detectEthereumProvider();
      if (!provider) {
        setError("MetaMask가 설치되어 있지 않습니다.");
        return;
      }

      const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      const address = accounts[0];

      const res = await instance.post(
        "/user/metamask-register",
        { name, address },
        { withCredentials: true }
      );

      if (res.data.success) {
        navigate("/login");
      }
    } catch (err) {
      setError(err.response?.data?.message || "회원가입 실패");
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={(theme) => ({
        mt: 10,
        px: 4,
        py: 6,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      })}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        color="text.primary"
      >
        메타마스크 회원가입
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box component="form" noValidate autoComplete="off">
        <TextField
          label="닉네임"
          fullWidth
          margin="normal"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setError("");
          }}
          required
        />

        <Button
          variant="contained"
          fullWidth
          onClick={handleMetaRegister}
          sx={{ mt: 2 }}
        >
          지갑 연결 후 회원가입
        </Button>
      </Box>
    </Container>
  );
};

export default MetaRegister;

